import { render } from "./NewsBjwo.vue?vue&type=template&id=678af48d&scoped=true"
import script from "./NewsBjwo.vue?vue&type=script&lang=js"
export * from "./NewsBjwo.vue?vue&type=script&lang=js"

import "./NewsBjwo.vue?vue&type=style&index=0&id=678af48d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678af48d"]])

export default __exports__